interface EmbeddedImage {
  title: string
  uri: string
}

export const EmbeddedImage: React.FC<EmbeddedImage> = ({ title, uri }) => (
  <img alt={title} className="mx-auto" src={uri} />
)
